import React, { useState } from "react";
import '../styles/inicio.min.css';

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = (e) => {
        e.preventDefault();
        setMenuOpen(!menuOpen);
    };

  return (
    <header className="pilates-header">

            <a href="/" className="pilates-header-title">OsteoVitta Pilates Criciúma</a>

            <nav className="pilates-header-nav">
                <ul className="pilates-header-nav-list">
                    <li className="pilates-header-nav-item">
                        <a href="/" className="pilates-header-nav-link">Início</a>
                    </li>
                    <li className="pilates-header-nav-item">
                        <a href="/o-pilates" className="pilates-header-nav-link">O Pilates</a>
                    </li>
                    <li className="pilates-header-nav-item">
                        <a href="/beneficios" className="pilates-header-nav-link">Benefícios</a>
                    </li>
                    <li className="pilates-header-nav-item">
                        <a href="/equipamentos" className="pilates-header-nav-link">Equipamentos</a>
                    </li>
                    <li className="pilates-header-nav-item">
                        <a href="/contato" className="pilates-header-nav-link">Contato</a>
                    </li>
                    <li className="pilates-header-nav-item">
                        <a href="/planos" className="pilates-header-nav-link--red">Planos</a>
                    </li>
                </ul>
            </nav>

            <div className="pilates-header-menu">
                <button className="js--menu_action" onClick={toggleMenu}>Menu</button>
                <div className={`pilates-header-menu-overlay ${menuOpen ? "is--active" : ""}`} onClick={toggleMenu}>
                </div>
                <div className={`pilates-header-menu-container ${menuOpen ? "fade-in" : "fade-out"}`}
                     style={{display: `${menuOpen ? "block" : "none"}`}}>

                    <div className="pilates-header-menu-btn--top">
                        <button></button>
                        <button className="js--menu_action close" onClick={toggleMenu}>X</button>
                    </div>
                    <nav className="pilates-header-menu-nav mobile">
                        <ul className="pilates-header-menu-nav-list">
                            <li className="pilates-header-menu-nav-item">
                                <a href="/planos" className="pilates-header-menu-nav-link--red">Planos</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/" className="pilates-header-menu-nav-link">Início</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/o-pilates" className="pilates-header-menu-nav-link">O Pilates</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/beneficios" className="pilates-header-menu-nav-link">Benefícios do Pilates</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/equipamentos" className="pilates-header-menu-nav-link">Equipamentos</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/contato" className="pilates-header-menu-nav-link">Contato</a>
                            </li>
  
                            <li className="pilates-header-menu-nav-item">
                                <a href="https://www.instagram.com/osteovitta/" className="pilates-header-menu-nav-link" target="_blank">Siga-nos no Instagram</a>
                            </li>
                        </ul>
                    </nav>

                    <nav className="pilates-header-menu-nav desktop">
                        <ul className="pilates-header-menu-nav-list">
                            <li className="pilates-header-menu-nav-item">
                                <a href="planos" className="pilates-header-menu-nav-link--red">Planos</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/" className="pilates-header-menu-nav-link">Início</a>
                            </li>
                            
                            <li className="pilates-header-menu-nav-item">
                                <a href="/o-pilates" className="pilates-header-menu-nav-link">O Pilates</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/beneficios" className="pilates-header-menu-nav-link">Benefícios do Pilates</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/equipamentos" className="pilates-header-menu-nav-link">Equipamentos</a>
                            </li>

                            <li className="pilates-header-menu-nav-item">
                                <a href="/contato" className="pilates-header-menu-nav-link">Contato</a>
                            </li>

  
                            <li className="pilates-header-menu-nav-item">
                                <a href="https://www.instagram.com/osteovitta/" className="pilates-header-menu-nav-link" target="_blank">Siga-nos no Instagram</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
  );
}